import React from 'react';

export default class ShowMoreOrLess extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showMore: false };
    }

    render() {
        const { text } = this.props;
        const minTextLength = this.props.minTextLength ? this.props.minTextLength : 150;
        const { showMore } = this.state;

        return (
            <div>{!showMore
                ? <div>{!text || text.length <= (minTextLength + 1)
                    ? text
                    : <div>
                        {text.substr(0, minTextLength)}{'... '}
                        <button type="button" className="btn text-btn" onClick={() => this.setState({ showMore: true })}>
                            SEE MORE
                        </button>
                    </div>
                }</div>
                : <div>
                    {text}{' '}
                    <button type="button" className="btn text-btn" onClick={() => this.setState({ showMore: false })}>
                        SEE LESS
                    </button>
                </div>
            }</div>
        );
    }
}